import { assert } from '@ember/debug';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function validateDate(date) {
  assert('dates must be valid ISO strings', typeof date === 'string' && !Number.isNaN(new Date(date)));
}